<script>
export default {
  name: "inclusão",
};
</script>

<template>
  <div class="inclusion">
    <div
      class="
        container
        d-flex
        justify-content-center
        flex-column
        align-items-center
      "
    >
      <img src="@/assets/images/dpsp/banner-inclusion.png" alt="" />

      <p class="text">
        Seguimos trabalhando para promover uma cultura inclusiva e ter um time
        cada vez mais plural, com base no respeito e na equidade de nossas
        oportunidades. <br />
        <br />
        E reforçamos que você pode se inscrever em qualquer uma de nossas
        oportunidades internas, independente de gênero, etnia, raça, orientação
        sexual ou idade. E vale reforçar o mesmo para as pessoas com
        deficiência! Venha trabalhar conosco porque, para nós, o mais importante
        é você ser quem realmente é! <br />
        <br />
        #VemSerDPSP
      </p>
      <a
        href="https://www.grupodpsp.com.br/quem-somos/#diversidade"
        target="_blank"
      >
        Clique aqui para saber mais
      </a>
    </div>
    <div class="inclusion__knowledge">
      <img src="@/assets/images/dpsp/foto-conhecimento.png" alt="" />
      <h2>Acreditamos que o conhecimento pode transformar vidas!</h2>
      <p>
        E você sabia que a nossa Universidade Corporativa conta com diversos
        cursos e treinamentos que podem contribuir, ainda mais, para o seu
        autodesenvolvimento e te apoiar para conseguir aquela vaga que você
        ficou de olho aqui na nossa página? <br />
        <br />
        Isso porque temos cursos em diferentes temas, além de 6 escolas que
        formam a base de conteúdos e conhecimentos sobre a nossa empresa e
        negócio. Você consegue conferir os nossos cursos on-line
        <a
          class="not"
          href="https://hcm19.sapsf.com/login?bplte_company=drogariaso&_s.crb=8dtT6a6wetOzx%252fB8m4CmklVD%252fMMcg3gf5vESqQue0Js%253d#/login"
          target="_blank"
          >clicando aqui.</a
        >
        Fique de olho também nas nossas comunicações internas, estamos sempre
        divulgando oportunidades de desenvolvimento, como as nossas rodas de
        conversa, trilhas de aprendizagem e muito mais!
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.inclusion {
  img {
    width: 100%;
    max-width: 1100px;
  }
  a:not(.not) {
    background: #f7dd69;
    box-shadow: 0px 0px 29px #0000001a;
    border-radius: 24px;
    color: #2e3447;
    font-size: 0.9rem;
    border: none;
    min-height: 38px;
    line-height: 38px;
    padding: 0px 4rem;
    font-weight: bold;
    &:hover {
      background: lighten(#f7dd69, 9);
    }
  }
  p {
    text-align: center;
    max-width: 780px;
    font-size: 1.3rem;
    &.text {
      margin: 7rem 0px 5rem 0px;
    }
    @include media-breakpoint-down(md) {
      &.text {
        margin: 2rem 0px 2rem 0px;
      }
      font-size: 1.1rem;
    }
  }
  &__knowledge {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-top: 6rem;
    background: url("../../../assets/images/dpsp/point.svg") no-repeat;
    background-size: 100% 10%;
    background-position: top;
    h2 {
      margin: 4rem 0px 2rem 0px;
      max-width: 500px;
      text-align: center;
    }
    p {
      max-width: 900px;
    }
    img {
      margin-top: 100px;
      width: 100%;
      max-width: 1100px;
    }
    @include media-breakpoint-down(md) {
      margin-top: 1rem;
      h2 {
        margin: 2rem 0px 2rem 0px;
      }
      img {
        margin-top: 70px;
      }
    }
  }
}
</style>